import { IBestsellerItem, ITopBestsellerApiItem } from './types';

export const transformTopBestsellers = (
  items?: ITopBestsellerApiItem[] | null
): IBestsellerItem[] => {
  if (!Array.isArray(items) || items.length === 0) return [];

  return items.reduce<IBestsellerItem[]>((acc, item) => {
    if (!item?.name || item.url == null || item.price == null) return acc;

    acc.push({
      name: item.name,
      price: Number(item.price),
      link: item.url,
    });
    return acc;
  }, []);
};
